import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { CreateUserRequest, CreateUserResponse, DeleteUserRequest, DeleteUserResponse, ListUsersRequest, ListUsersResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminUserApi = createApi({
    reducerPath: "adminUserApi",
    baseQuery: baseQueryAdminWithAuth,
    tagTypes: ["Users"],
    endpoints: builder => ({
        listUsers: builder.query<ListUsersResponse, ListUsersRequest>({
            query: body => ({
                url: `user/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        }),
        createUser: builder.mutation<CreateUserResponse, CreateUserRequest>({
            query: body => ({
                url: "user/create",
                method: "POST",
                body
            })
        }),
        deleteUser: builder.mutation<DeleteUserResponse, DeleteUserRequest>({
            query: body => ({
                url: "user/delete",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useCreateUserMutation,
    useDeleteUserMutation,
    useLazyListUsersQuery,
    useListUsersQuery
} = adminUserApi;
